import { type StrategyData } from '@acepoker/api-core'
import { api } from './api'

export const getStrategy = async (roomId: string): Promise<StrategyData> =>
  await api().get(`/api/room/${roomId}/strategy`).json()
